export default __webpack_public_path__ + "static/media/photo-charte13.9e2c85fe.png";